import { DOWNLOAD_APP_BANNER_CLOSED } from '../config/types/action.mjs';
import { getDownloadAppBannerStorage } from '../utils/downloadAppBannerStorage.mjs';

const defaultState = {
  hasClosedDownloadAppBanner: false,
};

const initialState = getDownloadAppBannerStorage() ?? defaultState;

const downloadAppBannerReducer = (state = initialState, { type } = {}) => {
  switch (type) {
    case DOWNLOAD_APP_BANNER_CLOSED:
      return {
        ...state,
        hasClosedDownloadAppBanner: true,
      };
    default:
      return state;
  }
};

export { downloadAppBannerReducer };
